import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchHighlightedTopicsFailure, fetchHighlightedTopicsSuccess } from "entities/topics/actions";
import type { Topic } from "entities/topics/types";

export function* fetchHighlightedTopicsSaga() {
  try {
    const topics: Topic[] = yield apiFetch("topic/curated/highlighted");
    yield put(fetchHighlightedTopicsSuccess({ topics }));
  } catch {
    yield put(fetchHighlightedTopicsFailure({ logoutOnAuthError: true }));
  }
}
